import { arrowDirection } from "../../store/interfaces/IRouterStore";
import { LEFT, RIGHT } from "../../configs/ARROWS_DIRECTION_CONFIG";
import { useRouterStore } from "../../store/useRouterStore";
import { Button, Typography } from "@mui/material";
import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";
import LeftArrowIcon from "../GenericLayout/LeftArrowIcon";
import RightArrowIcon from "../GenericLayout/RightArrowIcon";
import { openStripes } from "../../animations/animateStripes";
import { updateRoute } from "../../helpers/updateBoothURL";
import { SimpleBox } from "../MaterialCustomComponents";
import { findBoothIndex } from "../../helpers/updateNextAndPreviousBoothURL";
import { useModelStore } from "../../store/useModelStore";
import { useEffect } from "react";

const ArrowNavigation = ({ isDeviceOnLandscape = false }) => {
  const {
    setIsInfoCategoryClicked,
    setHallZoomValue,
    isBoothVisitPartActive,
    setIsVideoClicked,
    isExpoPageLoaded,
    areControlPanelButtonsDisabled,
    setAreControlPanelButtonsDisabled,
  } = useComponentLoadingStateStore();
  const { setArrowDirection, newTrigger, hallID, boothID } = useRouterStore();
  const { booths } = useModelStore();

  useEffect(() => {
    if (!isExpoPageLoaded) return;
    setAreControlPanelButtonsDisabled(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpoPageLoaded]);

  const handleChangeButtons = (direction: arrowDirection) => {
    if (boothID === "") {
      setAreControlPanelButtonsDisabled(true);
    }
    setHallZoomValue(0);
    setIsVideoClicked(false);
    setIsInfoCategoryClicked("");
    setArrowDirection(direction);
    newTrigger();
  };

  const splitBoothID = (booth: string, direction: string) => {
    if (boothID === "") {
      return true;
    }
    if (direction === "left") {
      const hasBoothToTheLeft = findBoothIndex(booth, booths, "left");
      return hasBoothToTheLeft ? true : false;
    }
    if (direction === "right") {
      const hasBoothToTheRight = findBoothIndex(booth, booths, "right");
      return hasBoothToTheRight ? true : false;
    }
  };

  return (
    <SimpleBox
      sx={{
        pointerEvents: "none",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {!isBoothVisitPartActive && (
        <>
          {splitBoothID(boothID, "left") ? (
            <Button
              variant="controlPanel"
              onClick={() => handleChangeButtons(LEFT)}
              disabled={
                areControlPanelButtonsDisabled ||
                (Number(hallID) === 1 && boothID === "" ? true : false)
              }
              sx={{
                width: isDeviceOnLandscape ? "20px" : null,
                height: isDeviceOnLandscape ? "40px" : null,
              }}
            >
              <LeftArrowIcon
                width={isDeviceOnLandscape ? 15 : 25}
                height={isDeviceOnLandscape ? 15 : 30}
              />
            </Button>
          ) : (
            <SimpleBox></SimpleBox>
          )}
          {Number(hallID) === 6 && boothID === "" ? (
            <Button
              variant="controlPanel"
              sx={{
                color: "white",
                width: "120px",
                height: "90px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
              }}
              onClick={() =>
                openStripes(() => {
                  updateRoute("/conference_hall");
                })
              }
              disabled={areControlPanelButtonsDisabled ? true : false}
            >
              <Typography sx={{ color: "#ffffff" }}>Conference Hall</Typography>
              <RightArrowIcon width={20} height={20} />
            </Button>
          ) : splitBoothID(boothID, "right") ? (
            <Button
              variant="controlPanel"
              onClick={() => handleChangeButtons(RIGHT)}
              disabled={areControlPanelButtonsDisabled ? true : false}
              sx={{
                width: isDeviceOnLandscape ? "20px" : null,
                height: isDeviceOnLandscape ? "40px" : null,
              }}
            >
              <RightArrowIcon
                width={isDeviceOnLandscape ? 15 : 25}
                height={isDeviceOnLandscape ? 15 : 30}
              />
            </Button>
          ) : (
            <SimpleBox></SimpleBox>
          )}
        </>
      )}
    </SimpleBox>
  );
};

export default ArrowNavigation;
